import * as React from 'react'
import Button from '@mui/material/Button'
import DialogContent from '@mui/material/DialogContent'
import { BootstrapDialog, BootstrapDialogTitle } from 'common/AbstractModal/BootstrapDialog'

import { NewFlightRegistrationForm } from './NewFlightRegistrationForm'

export default function AddFlightRegistrationDialog({ userID }: AddFlightRegistrationDialogProps) {
  const [open, setOpen] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  //handle form submit api here
  return (
    <div>
      <Button variant='contained' onClick={handleClickOpen}>
        Add Flight Registration
      </Button>
      <BootstrapDialog
        fullWidth
        maxWidth='lg'
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={open}
      >
        <BootstrapDialogTitle onClose={handleClose}>
          Add Flight Registration
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <NewFlightRegistrationForm
            userID={userID}
            handleClose={handleClose}
          />
        </DialogContent>
      </BootstrapDialog>
    </div>
  )
}

interface AddFlightRegistrationDialogProps {
  userID: string
}
